// Weekend in the studio's working week. Bangladesh runs Fri–Sat, so the
// projected dates on the contact page skip those rather than Sat–Sun.
const WEEKEND = [5, 6];

// `n` working days after `from`, weekends skipped. Used to turn "within 24
// hours" into an actual date the visitor can hold us to — a promise with a
// weekday on it reads very differently from one without.
export const addWorkingDays = (from: Date, n: number) => {
  const d = new Date(from);
  let left = n;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    if (!WEEKEND.includes(d.getDay())) left -= 1;
  }
  return d;
};

// True once a job's deadline day has fully passed. The deadline is inclusive —
// a posting is still open on the closing date itself and only reads as closed
// from the following day. `now` is injectable so it stays testable.
export const isDeadlinePassed = (deadline: string, now: Date = new Date()) => {
  const end = new Date(deadline);
  if (Number.isNaN(end.getTime())) return false;
  end.setHours(23, 59, 59, 999);
  return now.getTime() > end.getTime();
};

// Parts rather than one string: the timeline card sets the day number at
// display size and the rest as supporting text.
export const dateParts = (d: Date) => ({
  weekday: d.toLocaleDateString("en-US", { weekday: "long" }),
  weekdayShort: d.toLocaleDateString("en-US", { weekday: "short" }),
  day: d.getDate(),
  month: d.toLocaleDateString("en-US", { month: "short" }),
  full: d.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  }),
});
